module.exports = __webpack_public_path__ + "img/mail-sent.abc62aba.svg";